import { ProductsSelectionForm } from '@shared/components/ProductsSelectionForm';
import { usePricesSettings } from '../../prices/PricesContext';

export const ProductsSettingsForm = () => {
  const { toggleColumn, selectedColIds, addColumn, selectedUserProducts } = usePricesSettings();

  return (
    <ProductsSelectionForm
      selectedColIds={selectedColIds}
      selectedUserProducts={selectedUserProducts}
      addColumn={addColumn}
      toggleColumn={toggleColumn}
    />
  );
};
